import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/hotels/search/restel',
    name: 'hotels-restel',
    component: () => import('../views/hotels/restel/agency/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/options/restel',
    name: 'hotels-options-restel',
    component: () => import('../views/hotels/restel/agency/options.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/hotels/reserve/restel',
    name: 'hotels-reserve-restel',
    component: () => import('../views/hotels/restel/agency/reserve.vue'),
    meta: { layout: appLayout }
  }
]
